<template>
        <div v-if="user.ovpJobConditions.length">
            <div class="row text-center mt-2"  :class="{'bg-light': isSelectedUser}">
                <div class="col-sm-1 text-left align-self-center">
                    <b-form-checkbox v-model="isSelectedUser" name="isActive" size="md"/>
                </div>
                <div class="col-sm-11">
                    <div class="row text-center mt-2 py-1">
                    
                        <div class="col-sm-3 text-left align-self-center c-pointer" v-b-toggle="`accordion-${user.id}`">{{ user.name }} {{ user.surname }}</div>
            
                        <div class="col-sm-3 text-left align-self-center" v-if="isSelectedUser">
                            <label class="d-block text-secondary text-left mb-0">Veselības pārbaudes veids</label>
                            <b-form-select id="period" class="w-100 py-1 ds-input" v-model="selectedHeathChechType" :options="healthChechTypeOptions"/>
                        </div>
                        <div class="col-sm-3" v-else></div>
                        
                        <div  class="col-sm-2 align-self-center" v-if="isSelectedUser && selectedHeathChechType === 2">
                            <ValidationProvider tag="div"
                                    class="mb-0"
                                    vid="health-check"
                                    mode="lazy"
                                    :customMessages="{required: 'Norādi ārpuskārtas pārbaudes veidu!'}"
                                    rules="required"
                                    v-slot="{errors}">
                                <label class="d-block text-secondary text-left mb-0">Iemesls</label>
                                <input type="text" id="health" class="w-100 py-1 ds-input" v-model="specificHeathChech">
                                <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="col-sm-2" v-else></div>
                        <div class="col-sm-2 text-center align-self-center">
                            <button class="ds-btn" @click.prevent="isApproveModalVisible = true" v-if="waitingForApprovalOvps.length">Apstiprināt OVP</button>
                        </div>
                        <div class="col-sm-2 text-right align-self-center">{{ user.ovpJobConditions[0].nextInspectionDate }}</div>
                    </div>
                </div>
            </div>
            <div class="row text-center mt-2">
                <b-collapse :id="`accordion-${user.id}`" class="col-sm-12" v-model="isSelectedUser">
                    <b-form-checkbox-group
                        v-model="selectedOvps"
                        name="user-ovp">
                        <div class="row text-center my-4">
                            <div class="col-sm-1 font-weight-bold text-left"></div>
                            <div class="col-sm-4 font-weight-bold text-left">Darba apstāklis</div>
                            <div class="col-sm-2 font-weight-bold text-left">Periods</div>
                            <div class="col-sm-1 font-weight-bold text-center">Ipašs</div>
                            <div class="col-sm-1 font-weight-bold text-center">Gaida apstiprinājumu</div>
                            <div class="col-sm-3 font-weight-bold text-right">Beigu termiņš</div>
                        </div>
                        <div class="row text-center mt-2" v-for="ovpJobCondition in user.ovpJobConditions" :key="ovpJobCondition.id">
                            <div class="col-sm-1 text-right align-self-center">
                                <b-form-checkbox :value="ovpJobCondition.formatedDocData" :disabled="ovpJobCondition.waitingForApproval" class="green-checkbox"></b-form-checkbox>
                            </div>
                            <div class="col-sm-4 text-left align-self-center">
                                {{ ovpJobCondition.ovpJobCondition.globalOvpJobCondition.name }}
                                <font-awesome-icon
                                    size="lg"
                                    v-if="ovpJobCondition.doctorsComment"
                                    v-b-tooltip.hover :title="ovpJobCondition.doctorsComment"
                                    icon="comment-medical" 
                                    class="ml-2"/>
                            </div>
                            <div class="col-sm-2 text-left align-self-center">{{ ovpJobCondition.formatedPeriod }}</div>
                            <div class="col-sm-1 text-center align-self-center">
                                <font-awesome-icon v-if="ovpJobCondition.ovpJobCondition.isSpecial" icon="toggle-on" class="mr-1"/>
                                <font-awesome-icon v-else icon="toggle-off" class="mr-1"/>
                            </div>
                            <div class="col-sm-1 text-center align-self-center">
                                <font-awesome-icon v-if="ovpJobCondition.waitingForApproval" icon="toggle-on" class="mr-1"/>
                                <font-awesome-icon v-else icon="toggle-off" class="mr-1"/>
                            </div>
                            <div class="col-sm-3 text-right align-self-center">{{ ovpJobCondition.nextInspectionDate }}</div>
                        </div>
                    </b-form-checkbox-group>
                </b-collapse>
            </div>
            <b-modal v-model="isApproveModalVisible" hide-footer no-close-on-backdrop body-class="p-2" header-class="bg-light align-items-center"
                        size="xl">
                <div slot="modal-title">
                    <h3 class="h4 text-dark font-weight-light m-0">OVP darba apstākļu apstiprināšama</h3>
                </div>
                <div slot="modal-header-close">
                </div>
                <UserOvpJobConditionConfirmBaseForm :ready-to-be-approved-ovps="waitingForApprovalOvps" @finished="handleOvpJobConditionApproval"/>
            </b-modal>
            <hr class="my-2"/>
        </div>
</template>
<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex';
    import {extend, ValidationProvider} from 'vee-validate';
    import {required} from 'vee-validate/dist/rules';


    import UserOvpJobConditionConfirmBaseForm from './UserOvpJobConditionConfirmBaseForm';
    import {User} from '../../../vuex/modules/user/models/user.models';
    import * as ovpStoreTypes from '../../../vuex/modules/ovp/ovp.store-types';
    import * as companyStoreTypes from '../../../vuex/modules/company/company.store-types';
    import * as rootStoreTypes from '../../../vuex/root.store-types'
    import * as authStoreTypes from "../../../vuex/modules/auth/auth.store-types";

    export default {
        name: 'user-ovp-job-condition-list-item',
        components: {ValidationProvider, UserOvpJobConditionConfirmBaseForm},
        props: {
            user: {
                type: User,
                required: true,
            }
        },
        data: () => ({
            isModalVisible: false,
            isApproveModalVisible: false,
            isSelectedUser: false,
            selectedOvps: [],
            healthChechTypeOptions: [{text: 'Pirmreizējā', value: 1}, {text: 'Ārpuskārtas', value: 2}, {text: 'Periodiskā', value: 3, selected: true}],
            specificHeathChech: '',
            selectedHeathChechType: 3,
        }),
        async created() {
            extend('required', required);
        },
        watch: {
            isSelectedUser(isSelected) {
                if (!isSelected) {
                    return this.unsetSelectedUsers(this.user.id);
                }

                let selectedOvps = [...this.regularOvpsWithOneYearPeriod, ...this.specialOvpsWithOneYearPeriod];

                if (!this.regularOvpsWithOneYearPeriod.length && !this.specialOvpsWithOneYearPeriod.length) {
                    selectedOvps = [...selectedOvps, ...this.user.ovpJobConditions.filter(ovpJobCondition => !ovpJobCondition.waitingForApproval).map(({formatedDocData}) => formatedDocData)];
                }

                this.selectedOvps = selectedOvps;
            },
            userData(selectedUser) {
                if (!selectedUser.userData.ovpJobConditions.length && !selectedUser.userData.specialOvpJobConditions.length) {
                    return;
                }

                return this.setSelectedUsers(selectedUser);
            },
            selectedOvps() {
                if (!this.selectedOvps.length) {
                    this.isSelectedUser = false
                }
            }
        },
        computed: {
            ...mapGetters('ovp', {
                /** @type {function|*} */
                isActiveRequest: ovpStoreTypes.GET_IS_ACTIVE_REQUEST,
                 /** @type {function|*} */
                selectedUsers: ovpStoreTypes.GET_SELECTED_OVP_USERS,
            }),
            ...mapGetters('company', {
                currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
            }),
            ...mapGetters('auth', {
                /** @type {CurrentUser|*} */
                currentUser: authStoreTypes.GET_CURRENT_USER,
            }),
            regularOvpsWithOneYearPeriod() {
                return this.user.ovpJobConditions
                    .filter(({ovpJobCondition, waitingForApproval}) => +ovpJobCondition.period === 1 && !ovpJobCondition.isSpecial && !waitingForApproval)
                    .map(({formatedDocData}) => formatedDocData);
            },
            specialOvpsWithOneYearPeriod() {
                return this.user.ovpJobConditions
                    .filter(({ovpJobCondition, waitingForApproval}) => +ovpJobCondition.period === 1 && ovpJobCondition.isSpecial && !waitingForApproval)
                    .map(({formatedDocData}) => formatedDocData);
            },
            selectedRegularOvps() {
                return this.selectedOvps.filter(({isSpecial}) => !isSpecial)
            },
            selectedSpecialOvps() {
                return this.selectedOvps.filter(({isSpecial}) => isSpecial)
            },
            selectedHeathChech() {
                return this.selectedHeathChechType === 2 ? this.specificHeathChech :  this.selectedHeathChechType;
            },
            userData() {
                return {
                        userId: this.user.id,
                        userData: {
                            specialOvpJobConditions: this.selectedSpecialOvps, 
                            ovpJobConditions: this.selectedRegularOvps,
                            healthCheck: this.selectedHeathChech,
                        }
                    }
            },
            waitingForApprovalOvps() {
                return this.user.ovpJobConditions.filter(({waitingForApproval}) => waitingForApproval);
            }

        },
        methods: {
            ...mapMutations({
                /** @type {function|*} */
                setAlertData: rootStoreTypes.SET_ALERT_DATA,
            }),
             ...mapMutations('ovp', {
                /** @type {function|*} */
                setSelectedUsers: ovpStoreTypes.SET_SELECTED_OVP_USERS,
                /** @type {function|*} */
                unsetSelectedUsers: ovpStoreTypes.UNSET_SELECTED_OVP_USERS,
            }),
            ...mapMutations('company', {
                /** @type {function|*} */
                setCurrentCompanyOvpJobConditions: companyStoreTypes.SET_CURRENT_COMPANY_OVP_JOB_CONDITIONS,
            }),
            ...mapActions('ovp', {
                /** @type {function|*} */
                removeOvpJobCondition: ovpStoreTypes.ACTION_REMOVE_OVP_JOB_CONDITION,
                /** @type {function|*} */
                getOvpJobConditions: ovpStoreTypes.ACTION_GET_OVP_JOB_CONDITIONS,
                /** @type {function|*} */
                updateOvpJobCondition: ovpStoreTypes.ACTION_UPDATE_OVP_JOB_CONDITION,
            }),
            async handleOvpJobConditionRemoval() {
                const hasConfirmed = await this.$bvModal.msgBoxConfirm('Esi pārliecināts, ka vēlies dzēst darba apstākli?', {
                    okTitle: 'Jā',
                    cancelTitle: 'Nē',
                });

                if (!hasConfirmed) {
                    return;
                }

                try {
                    await this.removeOvpJobCondition({ovpJobConditionId: this.ovpJobCondition._id, companyId: this.currentCompany._id});

                    this.setAlertData({type: 'primary', message: 'Darba apstāklis izdzēsts!'});
                    const ovpJobConditions = await this.getOvpJobConditions({companyId: this.currentCompany._id});

                    if (!this.currentCompany._id) {
                        return;
                    }
              
                    this.setCurrentCompanyOvpJobConditions(ovpJobConditions);
                } catch (err) {
                    //
                }
            },
            async handleOvpJobConditionyUpdate() {
                this.isModalVisible = false;
                this.updateOvpJobCondition(this.ovpJobCondition);
                this.getOvpJobConditions({companyId: this.currentCompany._id});
            },
            async handleOvpJobConditionApproval() {
                this.isApproveModalVisible = false;
            },
        },
    }
</script>